import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import PersonIcon from '@material-ui/icons/Person';
import {Link} from 'react-router-dom';
import {formatPercent} from '../utils/formatPercent';
import {format} from 'date-fns';
import {GetData} from '../utils/Storage';

const CouponTable = ({coupons}) => {
  const user = GetData('business');

  const eligibleUsers = {
    all: 'Todos',
    old: 'Antigos',
    news: 'Novos',
  };

  const eligiblePlans = {
    all: 'Todos',
    Y: 'Anual',
    M: 'Mensal',
  };

  

  if (coupons.length === 0) {
    return <h1>Carregando...</h1>;
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{minWidth: 650}} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Código</TableCell>
            <TableCell align="right">Valor</TableCell>
            <TableCell align="right">Limite</TableCell>
            <TableCell align="right">Status de Uso</TableCell>
            <TableCell align="center">Data inicio/final</TableCell>
            <TableCell align="center">Data de Expiração</TableCell>
            <TableCell align="center">Número de Parcelas</TableCell>
            <TableCell align="center">Planos Elegíveis</TableCell>
            <TableCell align="center">Usuários Elegíveis</TableCell>
            <TableCell align="right">Status</TableCell>
            <TableCell align="right">
              {user.adminMaster ? 'Ações' : 'Usuários'}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {coupons.map((row, index) => {
            const startDate = format(
              new Date(row.startDate.split('T')[0] + 'T12:00:00'),
              'dd/MM/yyyy',
            );
            const endDate = format(
              new Date(row.endDate.split('T')[0] + 'T12:00:00'),
              'dd/MM/yyyy',
            );
            const expirationDate = row.expirationDate
              ? format(
                  new Date(row.expirationDate.split('T')[0] + 'T12:00:00'),
                  'dd/MM/yyyy',
                )
              : '-';

            return (
              <TableRow
                key={index}
                sx={{'&:last-child td, &:last-child th': {border: 0}}}>
                <TableCell component="th" scope="row">
                  {row.couponCode}
                </TableCell>
                <TableCell align="right">
                  {' '}
                  {row.discountType === 'fixed'
                    ? ` R$ ${row.value?.replace('.', ',')}`
                    : `${formatPercent(row.value)}`}
                </TableCell>
                <TableCell align="right">{row.usageOriginalLimit}</TableCell>
                <TableCell align="right">
                  {`${row.usageLimit} / ${row.usageOriginalLimit}`}
                </TableCell>
                <TableCell align="center">
                  {startDate} até {endDate}
                </TableCell>
                <TableCell align="center">{expirationDate}</TableCell>
                <TableCell align="center">
                  {row.numberRenewalLimits || '-'}
                </TableCell>
                <TableCell align="center">
                  {eligiblePlans[row.eligiblePlans]}
                </TableCell>
                <TableCell align="center">
                  {eligibleUsers[row.eligibleUsers]}
                </TableCell>
                <TableCell align="right">
                  {row.status === 'active' ? 'Ativo' : 'Inativo'}
                </TableCell>
                <TableCell align="right">
                  {user.adminMaster && (
                    <IconButton
                      component={Link}
                      to={`/cupons/edit/${row.id}`}
                      edge="end">
                      <EditIcon />
                    </IconButton>
                  )}
                  <IconButton
                    component={Link}
                    to={`/usuarios-cupons?cupom=${row.id}`}
                    edge="end">
                    <PersonIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CouponTable;
